import React from 'react';
import StatusIcon from './StatusIcon';
import { useSelector } from 'react-redux';

function UserStatus(props) {
	const usersState = useSelector(({ users }) => users);

   let filteredUser = usersState.users && usersState.users.status && usersState.users.status.filter(function (currentElement) {
		return parseInt(currentElement.id) === parseInt(props.user);
	});

    return(
        props.contact === true ?
            <StatusIcon status={""} />
            :
            props.group === false ?
                filteredUser && filteredUser[0] && filteredUser[0].calling === true ?
                    <StatusIcon status={filteredUser && filteredUser[0] && filteredUser[0].is_connected ? "calling" : "invisible-status"} />
                :
                    <StatusIcon status={filteredUser && filteredUser[0] && filteredUser[0].is_connected ? filteredUser[0].userstatus : "invisible-status"} />
            :
                <StatusIcon status={"group-status"} />
    )
}

export default UserStatus;